import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Grid,
  IconButton,
  FormControl,
	MenuItem,
	Select,
	Typography,
  Avatar,
  Box,
  Popover,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LeafletMap from "app/components/LeafletMap/LeafletMap";
import "./Screen1.css"
import DataSources from "./DataSources"
import Overview from "./Screen1Graphs/Overview";

import Outcome from "./Screen1Graphs/Outcome";
import Demographics from "./Screen1Graphs/Demographics";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import HeliosHeader from '../../../../../components/common/SevenScreenHeader/HeliosHeader'
import {
  fetchMapsData,
  fetchRegionsData,
  fetchScoresData,
  fetchOutcomeData,
  fetchDemographicsData,
  updateSelectedRegion
} from "../../../HomeSevenScreen/7screen/redux/screen1/actions"
import {
  fetchAverageData,
  fetchCountData,
  fetchPercentData,
  fetchGrowthData
} from "../../../HomeSevenScreen/7screen/redux/screen2/actions";
import {
  fetchAverageDataScreen3,
  fetchAgeData,
  fetchRaceData,
  fetchGenderData,
} from "../../../HomeSevenScreen/7screen/redux/screen3/actions";
import {
  changeScreenOrientation,
  updateDataSources,
} from "../../../HomeSevenScreen/7screen/redux/ScreensCommon/actions";
import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";



const Screen1NavTitles = ["Overview", "Education and Income", "Demographics"];
const MapNavTitles = ["Education", "Industry"];
class Screen1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMapIndex: 0,
      subMenuIndex: 0,
    }
  }

  componentDidMount() {
    this.props.fetchMapsData();
    this.props.fetchRegionsData();
    this.props.fetchScoresData(this.props.regionSelected);
    this.props.fetchOutcomeData(this.props.regionSelected);
    this.props.fetchDemographicsData(this.props.regionSelected);
  }

  handleScreenToggle = () => {
    this.props.changeScreenOrientation();
    //log screen orientation toggle
    logActivity({
      screen : UserActivityConstants.SCREEN1.NAME,
      action_type :  UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_SCREEN_ORIENTATION,
      action_target : `${this.props.orientationHorizontal ? "Vertical" : "Horizontal"}`
    });
  };

  handleDataSourceToggle = () => {
    this.props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN1.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action_target : `${this.props.displayDataSources ? "Hide data source" : "Show data source"}`
    })
  }

  handleRegionChange = (event) => {
    const {
      target: { value },
    } = event;
    let region = value;
    this.props.updateSelectedRegion(region);
    this.props.fetchScoresData(region);
    this.props.fetchOutcomeData(region);
    this.props.fetchDemographicsData(region);
  //  this.props.fetchAverageData(region); @TODO: check if this is needed

   logActivity({
    screen: UserActivityConstants.SCREEN1.NAME,
    action_type: UserActivityConstants.ACTION_TYPES.CLICK,
    action: UserActivityConstants.SCREEN1.ACTIONS.CHANGE_REGION,
    action_target: region
    });
  };

  changeSubMenu = (i) => {
    this.setState({
      subMenuIndex: i,
    })
    logActivity({
      screen: UserActivityConstants.SCREEN1.NAME,
      action_type: UserActivityConstants.ACTION_TYPES.CLICK,
      action: UserActivityConstants.SCREEN1.ACTIONS.SELECT_SUB_MENU,
      action_target: Screen1NavTitles[i]
    })
  }
  changeMapMenu = (i) => {
    this.setState({
      selectedMapIndex: i,
    })

    logActivity({
      screen: UserActivityConstants.SCREEN1.NAME,
      action_type: UserActivityConstants.ACTION_TYPES.CLICK,
      action: UserActivityConstants.SCREEN1.ACTIONS.CHANGE_MAP_MENU,  
      action_target: MapNavTitles[i]
    })
  }


  render() {
    return (
      <div className="screen-wrapper">
        <header className="screen-header">
            <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Regional Overview</div>
          <div className="screen-menu">
            {Screen1NavTitles.map((title, i)=>(
              <div
                key={i}
                className={`screen-menu-item ${this.state.subMenuIndex === i ? 'selected' : ''}`}
                onClick={() => this.changeSubMenu(i)}
              >
                {title}
                <br/>
              </div>
            ))}
          </div>

          <IconButton
            id="screen-toggle"
            aria-label="toggle-screens-orientation"
            onClick={this.handleScreenToggle}
            style={{
              color: "white",
            }}
          >
            {
              this.props.orientationHorizontal
                ? <SwapVertIcon fontSize="large" className="swap-icon" />
                : <SwapHorizIcon fontSize="large" className="swap-icon" />
            }
          </IconButton>
          <HeliosHeader />

          {/* <ScreenDropdown /> */}
        </header>
        <Grid container className="screen-content-wrapper screen-content-wrapper-1">
          <Grid container className="screen-content-grid" style={{height: "915px"}}>
            <Grid item md={5.71}>
            {this.props.regionsData.length != 0 ?
              <Overview
                regions={this.props.regionsData}
                regionSelected={this.props.regionSelected}
                handleRegionChange={this.handleRegionChange}
                scoresData={this.props.scoresData}
              /> : <div style={{textAlign: "center"}}> No data available </div>
            }
            </Grid>
            <Grid item md={6.29}>
              {this.state.subMenuIndex === 0
              ? <div id="map-grid">
                  {this.props.mapsData && JSON.stringify(this.props.mapsData) != '{}' ?
                  <div className='map-select-wrapper'>
                    {MapNavTitles.map((title, i)=>(
                      <div
                        key={i}
                        className={`map-menu-item ${this.state.selectedMapIndex === i ? 'selected' : ''}`}
                        onClick={() => this.changeMapMenu(i)}
                      >
                        {title}
                        <br/>
                      </div>
                    ))}
                  </div> : null }
                  {/* <div className="levelOfEducation-dropdown">
                    <FormControl sx={{ width: "290px" }}>
                      <Typography variant="inherit" className="form-metrics-header">
                        Level of education
                      </Typography>
                      <Select
                      // TODO: Add this from props, for now hardcoding
                        value="Graduate"
                        // onChange={}
                        input={<BootstrapInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                        className="select-mui"
                      >

                      </Select>
                    </FormControl>
                  </div> */}
                  {this.props.mapsData && JSON.stringify(this.props.mapsData) != '{}' ?
                  <LeafletMap
                    minZoom={7}
                    mapsData={this.props.mapsData[MapNavTitles[this.state.selectedMapIndex]]}
                    navTitle={MapNavTitles[this.state.selectedMapIndex]}
                  /> : <div style={{textAlign: "center"}}> No data available </div> }
                </div>

              : this.state.subMenuIndex === 1
              ? this.props.outcomeData.length != 0 && this.props.outcomeData[0].data.length != 0 ?
                <Outcome
                  outcomeData={this.props.outcomeData}
                  outcomeToolBarData={this.props.outcomeToolBarData}
                /> : <div style={{textAlign: "center"}}> No data available </div>

              : this.state.subMenuIndex === 2
              ? this.props.raceData.length != 0 || this.props.ageData.length != 0 ?
                <Demographics
                    raceData={this.props.raceData}
                    ageData={this.props.ageData}
                  /> : <div style={{textAlign: "center"}}> No data available </div>
              : <>
              </>
              }
            </Grid>
          </Grid>
        </Grid>
        { this.props.displayDataSources && <DataSources onClose={this.handleDataSourceToggle}/> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    regionsData: [ ...state.Screen1Reducer.regionsData ],
    scoresData: [ ...state.Screen1Reducer.scoresData ],
    outcomeData: [ ...state.Screen1Reducer.outcomeData ],
    outcomeToolBarData: { ...state.Screen1Reducer.outcomeToolBarData },
    raceData: { ...state.Screen1Reducer.raceData },
    ageData: { ...state.Screen1Reducer.ageData },
    mapsData: { ...state.Screen1Reducer.mapsData },
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    averageData: { ...state.Screen2Reducer.averageData },
    countData: { ...state.Screen2Reducer.countData },
    percentData: { ...state.Screen2Reducer.percentData },
    growthData: { ...state.Screen2Reducer.growthData },
    regionSelected: state.Screen1Reducer.regionSelected
  };
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
      updateDataSources,
      fetchMapsData,
      fetchRegionsData,
      fetchScoresData,
      fetchOutcomeData,
      fetchDemographicsData,
      fetchAverageData,
      fetchCountData,
      fetchPercentData,
      fetchGrowthData,
      updateSelectedRegion,
      fetchAverageDataScreen3,
      fetchAgeData,
      fetchRaceData,
      fetchGenderData,
    },
    dispatch
  );
}


export default connect(mapStateToProps, mapDispatchToProps)(Screen1);
